import * as React from 'react';
import { InlineText2, ArticleHeading2, Image } from '@cian/ui-kit';
import { pathOr } from 'ramda';

import * as styles from './styles.css';
import { IBuilder } from '../../../../types/newbuilding/builder';
import { Link } from '../../../Link';
import { getDoneStatsString, getInPeogressStatsString } from '../../utils/stats';

export function BuilderItem({ name, logoUrl, stats }: IBuilder) {
  const doneHousesText = getDoneStatsString(stats);
  const doneUrl = pathOr(null, ['done', 'qs'], stats);
  const inProgressHousesText = getInPeogressStatsString(stats);
  const inProgressUrl = pathOr(null, ['inProgress', 'qs'], stats);

  const preventDefault = React.useCallback((e: React.MouseEvent) => {
    e.preventDefault();
  }, []);
  const stopPropagation = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <div className={styles['container']} onClick={preventDefault}>
      <div className={styles['present-info']}>
        <div>
          <InlineText2 color="gray60_100">Застройщик</InlineText2>
          <ArticleHeading2 as="h2">{name}</ArticleHeading2>
        </div>
        {logoUrl && <Image src={logoUrl} width={48} height={48} borderRadius="4px" objectFit="contain" />}
      </div>
      <div className={styles['stats-links']}>
        {doneHousesText && doneUrl && (
          <div className={styles['stats-link']}>
            <InlineText2>Сдано: </InlineText2>
            <Link url={doneUrl} target="blank" onClick={stopPropagation}>
              {doneHousesText}
            </Link>
          </div>
        )}
        {inProgressHousesText && inProgressUrl && (
          <div className={styles['stats-link']}>
            <InlineText2>Строится: </InlineText2>
            <Link url={inProgressUrl} target="blank" onClick={stopPropagation}>
              {inProgressHousesText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
